import { monitor, MonitorEvent } from '@/services/monitor';
import { StrategyId } from './types';

export type OptimizerEvent =
  | 'form_optimizer_recommendation_impression'
  | 'form_optimizer_recommendation_applied'
  | 'form_optimizer_recommendation_apply_failed'
  | 'form_optimizer_recommendation_dismissed'
  | 'form_optimizer_recommendation_undone'
  | 'form_optimizer_recommendation_parse_failed';

export function reportFormOptimizerEvent(
  eventName: OptimizerEvent,
  strategyId: StrategyId,
  evidenceVersion: string,
  extra: Record<string, unknown> = {}
): void {
  monitor({
    event: MonitorEvent.Function,
    function: eventName,
    file: 'wheelOfFortune/pop/optimizer',
    data: { strategy_id: strategyId, evidence_version: evidenceVersion, ...extra },
  });
}
